
export class AreaImportSimpleData {
    constructor(name: string, text: string){
        this.Name = name;
        this.Text = text;
    }
    Name:string = "";
    Text:string = "";
}
